import { MolsonBox } from '@components/reusable'
import type { SxProps } from '@mui/material'
import { type molsonTheme } from '@theme'
import { molsonUseTheme } from '@theme/customMuiExports'

type ChipProps = {
  customSx?: SxProps<typeof molsonTheme>
  text: string
}

export const CustomChip = ({ customSx, text }: ChipProps) => {
  const theme = molsonUseTheme()

  const defaultSx = {
    bgcolor: theme.palette.primary.lightest,
    border: `1px solid ${theme.palette.secondary[0]}`,
    borderRadius: '25px',
    color: theme.palette.primary.darkest,
    cursor: 'default',
    fontSize: 14,
    fontWeight: 700,
    padding: '5px 10px 5px 10px',
    width: 'fit-content',
    ...customSx
  }

  return <MolsonBox sx={defaultSx}>{text}</MolsonBox>
}
